import type { PurchaseRequisition } from '../types/purchasing';
import type { ApprovalTrailFollowOn } from '../components/purchasing/ApprovalMap';
import type { EnhancedDeal, TimberProject } from '../types';
import {
  billPaymentPurchaseUiGuide,
  purchaseFollowsSupplierBill,
} from './purchaseOrderIssue';
import {
  purchaseDisplayedPurchasedAt,
  purchasePurchaserDisplayName,
} from './purchaseRequesterDisplay';

export function purchaseListApprovalFollowOn(
  row: PurchaseRequisition,
  timberProjects: TimberProject[],
  deals: EnhancedDeal[],
): ApprovalTrailFollowOn | undefined {
  if (row.status === 'cancelled') return undefined;
  const paymentMethod = row.paymentMethodId ?? row.paymentMethod;
  const followsBill = purchaseFollowsSupplierBill(paymentMethod);
  const billGuide = followsBill
    ? billPaymentPurchaseUiGuide({
        paymentMethod,
        designerInvoiceId: row.designerInvoiceId,
        dealId: row.dealId,
        timberProjects,
        deals,
      })
    : null;
  return {
    roleLabel: followsBill ? 'Bill payment' : 'Purchase',
    userName: followsBill && row.status !== 'purchased' ? undefined : purchasePurchaserDisplayName(row),
    at: purchaseDisplayedPurchasedAt(row),
    note: row.status === 'purchased' ? undefined : billGuide?.stepNote || row.paymentMethodNote,
    done: row.status === 'purchased',
  };
}
